import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomActionButton, {atomActionButtonStyles} from '@s-ui/react-atom-action-button'
import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import IconShare from '@adv-mt/mt-svg-icons/lib/Share'
import IconShareOutline from '@adv-mt/mt-svg-icons/lib/ShareOutline'

export const SHARE_URL_BUTTON_TYPES = {
  ACTION_BUTTON: 'actionButton',
  INLINE_BUTTON: 'inlineButton',
  INLINE_BUTTON_OUTLINE: 'inlineButtonOutline',
  ICON_BUTTON: 'iconButton',
  ICON_BUTTON_NEGATIVE: 'iconButtonNegative',
  ICON_BUTTON_OUTLINE: 'iconButtonOutline',
  MENU_BUTTON: 'menuButton',
  ICON: 'icon'
}

const ShareUrlButton = ({alignment, icon = <IconShare />, onClick, size, type}) => {
  const {i18n} = useContext(Context)
  const commonButtonProps = {
    'aria-label': i18n.t('COMMON.SHARE')
  }

  switch (type) {
    case SHARE_URL_BUTTON_TYPES.ICON:
      return <IconShare onClick={onClick} size="medium" />

    case SHARE_URL_BUTTON_TYPES.ICON_BUTTON:
      return (
        <AtomButton
          {...commonButtonProps}
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.FLAT}
          leftIcon={icon}
          onClick={onClick}
          size={size}
        />
      )
    case SHARE_URL_BUTTON_TYPES.ICON_BUTTON_NEGATIVE:
      return (
        <AtomButton
          {...commonButtonProps}
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.FLAT}
          leftIcon={<IconShareOutline />}
          onClick={onClick}
          size={size}
          negative
        />
      )
    case SHARE_URL_BUTTON_TYPES.ICON_BUTTON_OUTLINE:
      return (
        <AtomButton
          {...commonButtonProps}
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.OUTLINE}
          leftIcon={icon}
          onClick={onClick}
          size={size}
          negative
        />
      )
    case SHARE_URL_BUTTON_TYPES.INLINE_BUTTON:
      return (
        <AtomButton
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.FLAT}
          leftIcon={icon}
          onClick={onClick}
          size={size}
        >
          {i18n.t('COMMON.SHARE')}
        </AtomButton>
      )
    case SHARE_URL_BUTTON_TYPES.INLINE_BUTTON_OUTLINE:
      return (
        <AtomButton
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.OUTLINE}
          leftIcon={icon}
          onClick={onClick}
          size={size}
          negative
        >
          {i18n.t('COMMON.SHARE')}
        </AtomButton>
      )
    case SHARE_URL_BUTTON_TYPES.MENU_BUTTON:
      return (
        <AtomButton
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          design={atomButtonDesigns.FLAT}
          leftIcon={icon}
          onClick={onClick}
          size={size}
          fullWidth
        >
          {i18n.t('COMMON.SHARE')}
        </AtomButton>
      )
    default:
      return (
        <AtomActionButton
          alignment={alignment}
          shape={atomButtonShapes.CIRCULAR}
          onClick={onClick}
          icon={icon}
          style={atomActionButtonStyles.FLAT}
        >
          {i18n.t('COMMON.SHARE')}
        </AtomActionButton>
      )
  }
}

ShareUrlButton.displayName = 'ShareUrlButton'

ShareUrlButton.propTypes = {
  alignment: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(atomButtonSizes)),
  type: PropTypes.oneOf(SHARE_URL_BUTTON_TYPES)
}

export default ShareUrlButton
